import { setupSubscribeForm } from "./subscribe-form/utils/subscribe-form-util";

(function () {
	const forms = document.querySelectorAll(
		"form.subscribe-form",
	) as NodeListOf<HTMLFormElement>;
	if (!forms.length) return;

	forms.forEach(function (form) {
		setupSubscribeForm(form);
	});
})();
